// import { useEffect } from 'react';
import useStore from '@/store/store';
import { urlBase64ToUint8Array } from './urlBase64ToUint8Array';
import profileController from '@/services/ProfileController';

export const useWebPush = () => {
	//   const { user } = useStore();
	//   useEffect(() => {
	//     console.log("eee");
	//     if (isEligibile(user)) {
	//       initWebPush();
	//     }
	//   }, [user]);
	// useEffect(() => {
	// 	if (!('serviceWorker' in navigator)) {
	// 		console.log('isnt supported service');
	// 		// Service Worker isn't supported on this browser, disable or hide UI.
	// 		return;
	// 	}
	// 	if (!('PushManager' in window)) {
	// 		console.log('isnt supported push');
	// 		// Push isn't supported on this browser, disable or hide UI.
	// 		return;
	// 	}
	// 	const showNotification = event => {
	// 		console.log('daaaaa app');
	// 		const options = {
	// 			body: 'Simple piece of body text.\nSecond line of body text :)',
	// 		};
	// 		//   self.Notification.showNotification('dasdas', options)
	// 		Notification.showNotification('dasdas', options);
	// 		return new self.Notification(title, notificationOptions);
	// 	};
	// 	return () => {
	// 		window.removeEventListener('push', showNotification);
	// 	};
	// }, []);
	//   const initWebPush = async () => {
	//     try {
	//       const res = await askPermission();
	//       //   registerServiceWorker();
	//       console.log("resδαδασδα", res);
	//       //   setTimeout(() => {
	//       //     subscribe();
	//       //   }, 5000);
	//     } catch (err) {
	//       console.log("initWebPush err:", err);
	//     }
	//   };
	//   const askPermission = async () => {
	//     const permissionResult_1 = await new Promise(function (resolve, reject) {
	//       const permissionResult = Notification.requestPermission(function (result) {
	//         resolve(result);
	//       });
	//       if (permissionResult) {
	//         permissionResult.then(resolve, reject);
	//       }
	//     });
	//     if (permissionResult_1 !== "granted") {
	//       throw new Error("We weren't granted permission.");
	//     }
	//   };
	//   const registerServiceWorker = async () => {
	//     try {
	//       const registration = await navigator.serviceWorker.register("/service-worker.js");
	//       console.log("Service worker successfully registered.");
	//       return registration;
	//     } catch (err) {
	//       console.error("Unable to register service worker.", err);
	//     }
	//   };
};

const isEligibile = user => {
	return !(
		!(process.env.NODE_ENV === 'development' && user?.id === 56) &&
		!(
			process.env.NODE_ENV !== 'development' &&
			user?.id === 8236 &&
			user.cityLocation?.id === 23 &&
			window.location.href.includes('solvd')
		)
	);
};

export const pushLogin = async user => {
	try {
		if (!isEligibile(user)) {
			return;
		}

		await askPermission();

		navigator.serviceWorker.register('/service-worker.js').then(registration =>
			registration.pushManager
				.subscribe({
					userVisibleOnly: true,
					applicationServerKey: urlBase64ToUint8Array(
						'BL0_5-dflcsDkpN8qey3QudCiuvDjNm758AHjoTCPKiuKmh6m7VSysLl74PxjnqgfqpRjkAUXTk38HiRldNpmXU',
					),
					// applicationServerKey: 'BL0_5-dflcsDkpN8qey3QudCiuvDjNm758AHjoTCPKiuKmh6m7VSysLl74PxjnqgfqpRjkAUXTk38HiRldNpmXU'
				})
				.then(function (pushSubscription) {
					//   console.log("aaaa subscription in store: ", subscription);
					console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
					useStore.getState().setSubscription(pushSubscription);
					profileController.subscribe(pushSubscription);

					return pushSubscription;
				}),
		);
	} catch (err) {
		console.log('error sub login', err);
	}
};

export const askPermission = async () => {
	//   const permissionResult_1 = await new Promise(function (resolve, reject) {
	//     const permissionResult = Notification.requestPermission(function (result) {
	//       resolve(result);
	//     });

	//     if (permissionResult) {
	//       permissionResult.then(resolve, reject);
	//     }
	//   });
	const permissionResult_1 = await Notification.requestPermission();
	//   console.log("EDOOOOO", permissionResult_1);
	if (permissionResult_1 !== 'granted') {
		throw new Error("We weren't granted permission.");
	}
};

export const pushLogout = () => {
	try {
		if ('serviceWorker' in navigator) {
			//   console.log("yes onLogout", useStore.getState().subscription);

			profileController.unsubscribe(useStore.getState().subscription);

			navigator.serviceWorker.getRegistrations().then(registrations => {
				registrations.forEach(registration => {
					//   console.log("111");
					registration.unregister();
				});
			});

			navigator.serviceWorker.ready.then(registration => {
				registration.pushManager.getSubscription().then(subscription => {
					if (subscription) {
						// console.log("222");

						return subscription.unsubscribe();
					}
				});
			});
		}
	} catch (err) {
		console.log('unsubscribe err: ', err);
	}
};
